import { useEffect, useState } from 'react';

/**
 * @name useClipboard
 * @param { string } text - The text to copy.
 * @param {Object} [options]
 * @param {number} options.successDuration
 */
export default function useClipboard(text, options) {
  const [isCopied, setIsCopied] = useState(false);
  const successDuration = options?.successDuration || 2000;

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (isCopied && successDuration) {
      const id = setTimeout(() => {
        setIsCopied(false);
      }, successDuration);

      return () => {
        clearTimeout(id);
      };
    }
  }, [isCopied, successDuration]);

  return [
    isCopied,
    () => {
      navigator?.clipboard.writeText(text).then(() => setIsCopied(true));
    }
  ];
}
